



































































































import { Component, Vue, Prop } from 'vue-property-decorator';

// this data comes from fB
type TableSection = {
  sums: object; // period -> accNo -> bigDecimal
  sums_per_period: object; // period -> bigDecimal
  sums_per_account: object; // accNo -> bigDecimal
  total_sum: string; // bigDecimal
  accounts: object; // accNo -> account_name
}

export type TableData = {
  agaSection: TableSection;
  ftrSection: TableSection;
}

@Component({})
export default class Bookkept extends Vue {
  @Prop({ type: Object, required: true }) private data!: TableData;

  private translate(key: string) {
    return this.$t(`PaycheckReport.AmeldingAndBookkeepingReconciliation.Bookkept.${key}`);
  }

  private get anyAccounts() {
    return Object.keys(this.agaAccounts).length || Object.keys(this.ftrAccounts).length;
  }

  private get periods() {
    if (this.data.agaSection) {
      return Object.keys(this.data.agaSection.sums_per_period);
    } else if (this.data.ftrSection) {
      return Object.keys(this.data.ftrSection.sums_per_period);
    } else {
      return [];
    }
  }

  private get agaAccounts(): object {
    return this.data.agaSection.accounts;
  }
  private get ftrAccounts(): object {
    return this.data.ftrSection.accounts;
  }

  private get agaAccountNumbers() {
    return Object.keys(this.agaAccounts);
  }
  private get ftrAccountNumbers() {
    return Object.keys(this.ftrAccounts);
  }
}
